import { ICorporationResponse } from '@kcftech/prometheus-client';
import { LocationTableCheckbox } from 'components/checkbox/LocationTableCheckbox';
import { Label } from 'components/forms/Label';
import { FieldTitle } from 'components/table/types';
import { sdClient } from 'contexts/SDKClientContext';
import { ILocationSummaryRow } from 'custom_hooks/data_hooks/data_source/locationAssetDataSource';
import { useInfiniteDataSource } from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import { usePagedDataSource } from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import styled from 'styled-components';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export const PaddedTable = styled.table`
    th,
    td {
        padding: 1rem 2rem;
        text-align: center;
    }
`;

export const usePagedCorporationData = (name: string) =>
    usePagedDataSource({
        name,
        defaultSort: [{ field: 'Name', dir: 'asc' }],
        defaultFilter: { name: '' },
        pageLimit: 10,
        query: ({ filter, sort, page, pageLimit }) => {
            const sortExpr = buildOrderBy(sort);

            const filterExpr =
                filter.name && filter.name.length > 0
                    ? Filter.startsWith('Name', filter.name)
                    : undefined;

            return toDataSourceResult(
                sdClient.getCorporations({
                    filter: filterExpr,
                    page,
                    pageLimit,
                    orderBy: sortExpr,
                }),
            );
        },
    });

export const corpItemKey = (corp: ICorporationResponse) => corp.Id;

export const renderCorp = (corp: ICorporationResponse) => corp.Name;

export const useInfiniteCorporationData = (name: string) =>
    useInfiniteDataSource<ICorporationResponse, { name: string }>({
        name,
        defaultSort: [{ field: 'Name', dir: 'asc' }],
        defaultFilter: { name: '' },
        pageLimit: 5,
        query: ({ filter, sort, page, pageLimit }) => {
            const sortExpr = buildOrderBy(sort);

            const filterExpr =
                filter.name && filter.name.length > 0
                    ? Filter.startsWith('Name', filter.name)
                    : undefined;

            return toDataSourceResult(
                sdClient.getCorporations({
                    filter: filterExpr,
                    page,
                    pageLimit,
                    orderBy: sortExpr,
                }),
            );
        },
    });

export const PaddedLabel = styled(Label)`
    margin-bottom: 1rem;
`;

export const Spacer = styled.div`
    margin-top: 1rem;
    margin-bottom: 2rem;
`;

export const fieldTitles: FieldTitle[] = [
    { key: 'name', title: 'Name' },
    { key: 'abbreviation', title: 'Abbrev.' },
    { key: 'active', title: 'Active' },
];

export const tableCheckbox = (dataItem: ILocationSummaryRow) => (
    <LocationTableCheckbox dataItem={dataItem} />
);
